import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const Cases = React.lazy(() => import("../screean/case/cases"));

export function caso() {
  return (
    <Route
      path="/casos"
      element={
        <ProtectedRoute>
          <LazySuspense>
            <Cases />
          </LazySuspense>
        </ProtectedRoute>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
